import { ContentLayoutF } from '@betterment/samba-react';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { ActionsCard } from './components/actions-card/ActionsCard';
import { FundamentalsCard } from './components/fundamentals-card/FundamentalsCard';
import { HoldingsCard } from './components/holdings-card/HoldingsCard';
import { OverviewCard } from './components/overview-card/OverviewCard';
import { SecurityPositionDetailsCard } from './components/security-position-details-card/SecurityPositionDetailsCard';
import { StatsCard } from './components/stats-card/StatsCard';

import { ApplicationLayout } from '../Shared/layout/ApplicationLayout';

export type Props = { accountId: string; securityId: string };

export const AccountSecurityPage: React.FC = () => {
  const accountId = useRequiredParam('accountId');
  const securityId = useRequiredParam('securityId');

  return (
    <ApplicationLayout pageTitle="Account Security" feature="account_security">
      <ApplicationLayout.Content>
        <ContentLayoutF>
          <ContentLayoutF.SlotContainer css={{ paddingTop: 'space.400' }}>
            <ContentLayoutF.Slot1
              css={{ display: 'grid', gap: { base: 'space.100', sm: 'space.300' }, gridAutoRows: 'max-content' }}
            >
              <OverviewCard accountId={accountId} securityId={securityId} />
              <StatsCard accountId={accountId} securityId={securityId} />
              <FundamentalsCard accountId={accountId} securityId={securityId} />
              <HoldingsCard accountId={accountId} securityId={securityId} />
            </ContentLayoutF.Slot1>
            <ContentLayoutF.Slot2
              css={{ display: 'grid', gap: { base: 'space.100', sm: 'space.300' }, gridAutoRows: 'max-content' }}
            >
              <ActionsCard accountId={accountId} securityId={securityId} />
              <SecurityPositionDetailsCard accountId={accountId} securityId={securityId} />
            </ContentLayoutF.Slot2>
          </ContentLayoutF.SlotContainer>
        </ContentLayoutF>
      </ApplicationLayout.Content>
    </ApplicationLayout>
  );
};
